import React, { useEffect, useState } from "react";
import styles from "./home.module.scss";
// import { useIntl, history, useModel } from 'umi';
import Layout from "../../layouts/User";
import Notices from "../../layouts/User/notice";
import { Button, Card, Checkbox, Col, message, Modal } from "antd";
import NetworkData from "../Register/network";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import {
  ONETRUST_PRIVACY,
  ONETRUST_PRIVACY_POLICY_URL,
  ONETRUST_SHARED_DATA,
  ONETRUST_TERMS_OF_USE_URL,
  ONETRUST_API_URL,
} from "../../config";
// import { history, useModel } from "umi";

export type Props = {};

const breadcrumbs = [
  {
    text: "หน้าแรก",
    path: "/",
  },
  {
    text: "ตั้งค่าการยอมรับสิทธิต่างๆ",
  },
];
// const formNotice = () => {
//   const url = `https://privacyportaluat.onetrust.com/webform/669247f0-b028-4f7e-a819-5e780546ba06/440c37d0-37fd-4404-9926-e16d770ecde7`;
//   window.open(url);
// };

const Notice: React.FC<Props> = (props) => {
  const user = useSelector((state: any) => state.user);

  const [notices1, setNotices1] = useState<any>();
  const [notices2, setNotices2] = useState<any>();

  const [isAgreement, setIsAgreement] = useState<any>(false);
  const [isAgreementData, setIsAgreementData] = useState<any>(false);
  const [isNetwork, setIsNetwork] = useState<any>(false);
  const [isNew, setNew] = useState<any>(false);
  const [isPersonalInformation, setPersonalInformation] = useState<any>(false);
  const [OneTrust, setOneTrust] = useState<any>(`${ONETRUST_API_URL}`);
  const [term, setTerm] = useState<any>();

  const getTerm = async () => {
    const allOrder = await axios.get(`/term-of-use/role?role=buyer`);
    setTerm(htmlDecode(allOrder.data.termOfUse));
  };
  const htmlDecode = (content: any) => {
    let e = document.createElement("div");
    e.innerHTML = content;
    return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
  };

  const openModalNetwork = () => {
    setIsNetwork(true);
  };
  const clossModal = () => {
    setIsAgreement(false);
    setIsAgreementData(false);
    setIsNetwork(false);
  };
  const addPdPa = () => {
    axios.get(`/pdpa-user/${user?._id}`).then(async (data) => {
      // console.log(data.data);
      const datetoset = new Date();
      let dataNew = data?.data?.pdpaDetail?.news?.acceptDate;
      if (isNew != data.data.pdpa.news) {
        dataNew = datetoset;
      }
      if (isNew === true) {
        axios.post(OneTrust, {
          identifier: user?.phone,
          // **** UAT START ****
          // requestInformation:
          //   "eyJhbGciOiJSUzUxMiJ9.eyJvdEp3dFZlcnNpb24iOjEsInByb2Nlc3NJZCI6ImNiY2ZlMDQ3LTgxOGEtNGQ3NC1iNTcxLWJiNDhkYTkwMGEwMSIsInByb2Nlc3NWZXJzaW9uIjoxLCJpYXQiOiIyMDIyLTA1LTMxVDA5OjEyOjAyLjE1NyIsIm1vYyI6IkFQSSIsInBvbGljeV91cmkiOm51bGwsInN1YiI6IkVtYWlsIiwiaXNzIjpudWxsLCJ0ZW5hbnRJZCI6IjY2OTI0N2YwLWIwMjgtNGY3ZS1hODE5LTVlNzgwNTQ2YmEwNiIsImRlc2NyaXB0aW9uIjoiUHJvbXB0RGVlX05ld3MgQnV5ZXIiLCJjb25zZW50VHlwZSI6IkNPTkRJVElPTkFMVFJJR0dFUiIsImFsbG93Tm90R2l2ZW5Db25zZW50cyI6ZmFsc2UsImRvdWJsZU9wdEluIjpmYWxzZSwicHVycG9zZXMiOlt7ImlkIjoiZjI2MTVkZjYtYWFjNi00YjdiLTk0ZWItZjA5MzNhMDY2YTZkIiwidmVyc2lvbiI6MSwicGFyZW50SWQiOm51bGwsInRvcGljcyI6W10sImN1c3RvbVByZWZlcmVuY2VzIjpbXSwiZW5hYmxlR2VvbG9jYXRpb24iOmZhbHNlfV0sIm5vdGljZXMiOltdLCJkc0RhdGFFbGVtZW50cyI6W10sImF1dGhlbnRpY2F0aW9uUmVxdWlyZWQiOmZhbHNlLCJyZWNvbmZpcm1BY3RpdmVQdXJwb3NlIjpmYWxzZSwib3ZlcnJpZGVBY3RpdmVQdXJwb3NlIjp0cnVlLCJkeW5hbWljQ29sbGVjdGlvblBvaW50IjpmYWxzZSwiYWRkaXRpb25hbElkZW50aWZpZXJzIjpbXSwibXVsdGlwbGVJZGVudGlmaWVyVHlwZXMiOmZhbHNlLCJlbmFibGVQYXJlbnRQcmltYXJ5SWRlbnRpZmllcnMiOmZhbHNlLCJwYXJlbnRQcmltYXJ5SWRlbnRpZmllcnNUeXBlIjpudWxsLCJhZGRpdGlvbmFsUGFyZW50SWRlbnRpZmllclR5cGVzIjpbXSwiZW5hYmxlR2VvbG9jYXRpb24iOmZhbHNlfQ.I6O1yi43O6k9Edx_yn2aROtVK4ecXftyn0b_HyEoqSG7svzgxBh0xIL-BptAAy5VHFKVf-P0KfcoV0iVwD2RQdg0EX9DFx4J_A87wpT_frAFFYuXoEAGW6cv3ThOeR8MV7uzgjdo0bJi1QDl2D0kf1tdTDL_0KfHXmu_lPtOZq6vAqp9ewhvssiNMrWgJHhORGEE8k1BujGT8I9oqhssuWRnw2PoHGnUwtnbtPz6LoXsa1Ew4q2PUsnhB_fnn3CSrUz0iZZCjooAxxtkrZij5fXyFjZfUfnegDCMnVLtCNtWpuaYAp5hExn-TLKnxWHnqfiPikyo0NzuKx4Prj0fDBlL4-wSBH8jijJrQXGnnP7udnrvepvniPzRpQ3TzyfVy0v4QRnjpPK2MyEDykok5Zgf87KXwclDUhw9nbgpjD5cwfzLqabT5J7y04IgAbJdD2Qa4Ip56tm0_D6urOlXOGOYq7tFKPcLXFcR18DHOh8w10mJFbUtx8Zacnb8i4UBwQEcFMDLSTl-KSTf1gV6sCztrbUQL4zI5zyJnE4DW2rl2F3dGG-DIQ915XDclLEA8HY1l73XhHG3JT2_dN6IYhQfEtlaa8-OaKYAsv9v9E_yR2b8gRWBk3RY381MdN216clW-DeuHwcgVaDTBpadWDEDC3ab9qduBdJ5MQ9po0o",
          // purposes: [
          //   {
          //     Id: "f2615df6-aac6-4b7b-94eb-f0933a066a6d",
          //     TransactionType: "CONFIRMED",
          //     //   "TransactionType": "WITHDRAWN"
          //   },
          // ],
          // **** UAT END ****
          // **** PRODUCTION START ****
          // requestInformation:
          //   "eyJhbGciOiJSUzUxMiJ9.eyJvdEp3dFZlcnNpb24iOjEsInByb2Nlc3NJZCI6ImEzOWYzOGZmLWI5OGMtNDhjNS04NDg0LTg3YjE1Yzg0MmY3OCIsInByb2Nlc3NWZXJzaW9uIjoxLCJpYXQiOiIyMDIyLTA1LTI3VDA2OjMxOjUxLjc1NyIsIm1vYyI6IkFQSSIsInBvbGljeV91cmkiOm51bGwsInN1YiI6IkVtYWlsIiwiaXNzIjpudWxsLCJ0ZW5hbnRJZCI6IjU3MGRjNGUwLTYxZmQtNDkyNi05MDk0LTI5MGQ3YjViM2NiNiIsImRlc2NyaXB0aW9uIjoiUHJvbXB0RGVlX0Nvb2tpZXMgQnV5ZXIgVUFUIiwiY29uc2VudFR5cGUiOiJDT05ESVRJT05BTFRSSUdHRVIiLCJhbGxvd05vdEdpdmVuQ29uc2VudHMiOmZhbHNlLCJkb3VibGVPcHRJbiI6ZmFsc2UsInB1cnBvc2VzIjpbeyJpZCI6IjM0ODIwZDczLWU5MmItNDk3Yi1hMmFlLTYxNDliMTRmZTNkZCIsInZlcnNpb24iOjIsInBhcmVudElkIjpudWxsLCJ0b3BpY3MiOltdLCJjdXN0b21QcmVmZXJlbmNlcyI6W10sImVuYWJsZUdlb2xvY2F0aW9uIjpmYWxzZX1dLCJub3RpY2VzIjpbXSwiZHNEYXRhRWxlbWVudHMiOltdLCJhdXRoZW50aWNhdGlvblJlcXVpcmVkIjpmYWxzZSwicmVjb25maXJtQWN0aXZlUHVycG9zZSI6ZmFsc2UsIm92ZXJyaWRlQWN0aXZlUHVycG9zZSI6dHJ1ZSwiZHluYW1pY0NvbGxlY3Rpb25Qb2ludCI6ZmFsc2UsImFkZGl0aW9uYWxJZGVudGlmaWVycyI6W10sIm11bHRpcGxlSWRlbnRpZmllclR5cGVzIjpmYWxzZSwiZW5hYmxlUGFyZW50UHJpbWFyeUlkZW50aWZpZXJzIjpmYWxzZSwicGFyZW50UHJpbWFyeUlkZW50aWZpZXJzVHlwZSI6bnVsbCwiYWRkaXRpb25hbFBhcmVudElkZW50aWZpZXJUeXBlcyI6W10sImVuYWJsZUdlb2xvY2F0aW9uIjpmYWxzZX0.KYSNg6-2j-PiAyIo1pAhSflG6z6dmxmT97bqTQgABvXoAQL-h1lR90eF6J9LMZtSywqm6TPNW566o5EQurkiQ5GtPMwq-x267t8U4DX7O9Z4niB9kazlZ-3muOgJyW-NSfL8cncm2wJtwAIy5R1jRvEpbRyE8N4fclmOJyl_7wlopBZe5HVd7qEYtDdZkxG7bhGt6XjVe6WFWdNsMF5D3zD8KJGuZEkHk7oqBV6s1BNCBDofitRzcnLs50g7jYc_31Dlh1JebNHPnFJpzFAABeSn3KKYbYYctZMHDhPjBdw0E8tZ1gSy_b8Nov8ZUPKatv5XimEWPaXgzC5ngVw5UlWaFXNs5P0_-XnYacBPJMEMrA7dN7WAv5koch9EQyJYrAkcnIb23jSV7CmXakfJoZKRns3LqxPmC6vP1aAQdHoRd5T_-xUxBb0SkPpzaEmKdZ7JKvTip7cw0vH0677IuaZhDGuGIZPgh4IB5xjQ0OgSS4NsdQ3rc3n72iDJ90D1hf7BRxU-XHIkElwisJGrBND6BGFflxmBTizIUOsAKqP-FTeX0_fNgytMoIvHy5T1rSOb9qJJYwJIt1P8WHAxxd_l5o3TWAHf382-3WYVkgid6x5aq8sJ2YQ8RZoNnQdDAl_72rrXgXvudGGMwZGg6Cg88h2Ki5WeOYvA2wfpbcw",
          // purposes: [
          //   {
          //     Id: "34820d73-e92b-497b-a2ae-6149b14fe3dd",
          //     TransactionType: "CONFIRMED",
          //     //   "TransactionType": "WITHDRAWN"
          //   },
          // ],
          // **** PRODUCTION END ****
          requestInformation: `${ONETRUST_PRIVACY.TOKEN}`,
          purposes: [
            {
              Id: `${ONETRUST_PRIVACY.ID}`,
              TransactionType: "CONFIRMED",
            },
          ],
        });
      } else {
        axios.post(OneTrust, {
          identifier: user?.phone,
          // **** UAT START ****
          // requestInformation:
          //   "eyJhbGciOiJSUzUxMiJ9.eyJvdEp3dFZlcnNpb24iOjEsInByb2Nlc3NJZCI6ImNiY2ZlMDQ3LTgxOGEtNGQ3NC1iNTcxLWJiNDhkYTkwMGEwMSIsInByb2Nlc3NWZXJzaW9uIjoxLCJpYXQiOiIyMDIyLTA1LTMxVDA5OjEyOjAyLjE1NyIsIm1vYyI6IkFQSSIsInBvbGljeV91cmkiOm51bGwsInN1YiI6IkVtYWlsIiwiaXNzIjpudWxsLCJ0ZW5hbnRJZCI6IjY2OTI0N2YwLWIwMjgtNGY3ZS1hODE5LTVlNzgwNTQ2YmEwNiIsImRlc2NyaXB0aW9uIjoiUHJvbXB0RGVlX05ld3MgQnV5ZXIiLCJjb25zZW50VHlwZSI6IkNPTkRJVElPTkFMVFJJR0dFUiIsImFsbG93Tm90R2l2ZW5Db25zZW50cyI6ZmFsc2UsImRvdWJsZU9wdEluIjpmYWxzZSwicHVycG9zZXMiOlt7ImlkIjoiZjI2MTVkZjYtYWFjNi00YjdiLTk0ZWItZjA5MzNhMDY2YTZkIiwidmVyc2lvbiI6MSwicGFyZW50SWQiOm51bGwsInRvcGljcyI6W10sImN1c3RvbVByZWZlcmVuY2VzIjpbXSwiZW5hYmxlR2VvbG9jYXRpb24iOmZhbHNlfV0sIm5vdGljZXMiOltdLCJkc0RhdGFFbGVtZW50cyI6W10sImF1dGhlbnRpY2F0aW9uUmVxdWlyZWQiOmZhbHNlLCJyZWNvbmZpcm1BY3RpdmVQdXJwb3NlIjpmYWxzZSwib3ZlcnJpZGVBY3RpdmVQdXJwb3NlIjp0cnVlLCJkeW5hbWljQ29sbGVjdGlvblBvaW50IjpmYWxzZSwiYWRkaXRpb25hbElkZW50aWZpZXJzIjpbXSwibXVsdGlwbGVJZGVudGlmaWVyVHlwZXMiOmZhbHNlLCJlbmFibGVQYXJlbnRQcmltYXJ5SWRlbnRpZmllcnMiOmZhbHNlLCJwYXJlbnRQcmltYXJ5SWRlbnRpZmllcnNUeXBlIjpudWxsLCJhZGRpdGlvbmFsUGFyZW50SWRlbnRpZmllclR5cGVzIjpbXSwiZW5hYmxlR2VvbG9jYXRpb24iOmZhbHNlfQ.I6O1yi43O6k9Edx_yn2aROtVK4ecXftyn0b_HyEoqSG7svzgxBh0xIL-BptAAy5VHFKVf-P0KfcoV0iVwD2RQdg0EX9DFx4J_A87wpT_frAFFYuXoEAGW6cv3ThOeR8MV7uzgjdo0bJi1QDl2D0kf1tdTDL_0KfHXmu_lPtOZq6vAqp9ewhvssiNMrWgJHhORGEE8k1BujGT8I9oqhssuWRnw2PoHGnUwtnbtPz6LoXsa1Ew4q2PUsnhB_fnn3CSrUz0iZZCjooAxxtkrZij5fXyFjZfUfnegDCMnVLtCNtWpuaYAp5hExn-TLKnxWHnqfiPikyo0NzuKx4Prj0fDBlL4-wSBH8jijJrQXGnnP7udnrvepvniPzRpQ3TzyfVy0v4QRnjpPK2MyEDykok5Zgf87KXwclDUhw9nbgpjD5cwfzLqabT5J7y04IgAbJdD2Qa4Ip56tm0_D6urOlXOGOYq7tFKPcLXFcR18DHOh8w10mJFbUtx8Zacnb8i4UBwQEcFMDLSTl-KSTf1gV6sCztrbUQL4zI5zyJnE4DW2rl2F3dGG-DIQ915XDclLEA8HY1l73XhHG3JT2_dN6IYhQfEtlaa8-OaKYAsv9v9E_yR2b8gRWBk3RY381MdN216clW-DeuHwcgVaDTBpadWDEDC3ab9qduBdJ5MQ9po0o",
          // purposes: [
          //   {
          //     Id: "f2615df6-aac6-4b7b-94eb-f0933a066a6d",
          //     // TransactionType: "CONFIRMED",
          //     TransactionType: "WITHDRAWN",
          //   },
          // ],
          // **** UAT END ****
          // **** PRODUCTION START ****
          // requestInformation:
          //   "eyJhbGciOiJSUzUxMiJ9.eyJvdEp3dFZlcnNpb24iOjEsInByb2Nlc3NJZCI6ImEzOWYzOGZmLWI5OGMtNDhjNS04NDg0LTg3YjE1Yzg0MmY3OCIsInByb2Nlc3NWZXJzaW9uIjoxLCJpYXQiOiIyMDIyLTA1LTI3VDA2OjMxOjUxLjc1NyIsIm1vYyI6IkFQSSIsInBvbGljeV91cmkiOm51bGwsInN1YiI6IkVtYWlsIiwiaXNzIjpudWxsLCJ0ZW5hbnRJZCI6IjU3MGRjNGUwLTYxZmQtNDkyNi05MDk0LTI5MGQ3YjViM2NiNiIsImRlc2NyaXB0aW9uIjoiUHJvbXB0RGVlX0Nvb2tpZXMgQnV5ZXIgVUFUIiwiY29uc2VudFR5cGUiOiJDT05ESVRJT05BTFRSSUdHRVIiLCJhbGxvd05vdEdpdmVuQ29uc2VudHMiOmZhbHNlLCJkb3VibGVPcHRJbiI6ZmFsc2UsInB1cnBvc2VzIjpbeyJpZCI6IjM0ODIwZDczLWU5MmItNDk3Yi1hMmFlLTYxNDliMTRmZTNkZCIsInZlcnNpb24iOjIsInBhcmVudElkIjpudWxsLCJ0b3BpY3MiOltdLCJjdXN0b21QcmVmZXJlbmNlcyI6W10sImVuYWJsZUdlb2xvY2F0aW9uIjpmYWxzZX1dLCJub3RpY2VzIjpbXSwiZHNEYXRhRWxlbWVudHMiOltdLCJhdXRoZW50aWNhdGlvblJlcXVpcmVkIjpmYWxzZSwicmVjb25maXJtQWN0aXZlUHVycG9zZSI6ZmFsc2UsIm92ZXJyaWRlQWN0aXZlUHVycG9zZSI6dHJ1ZSwiZHluYW1pY0NvbGxlY3Rpb25Qb2ludCI6ZmFsc2UsImFkZGl0aW9uYWxJZGVudGlmaWVycyI6W10sIm11bHRpcGxlSWRlbnRpZmllclR5cGVzIjpmYWxzZSwiZW5hYmxlUGFyZW50UHJpbWFyeUlkZW50aWZpZXJzIjpmYWxzZSwicGFyZW50UHJpbWFyeUlkZW50aWZpZXJzVHlwZSI6bnVsbCwiYWRkaXRpb25hbFBhcmVudElkZW50aWZpZXJUeXBlcyI6W10sImVuYWJsZUdlb2xvY2F0aW9uIjpmYWxzZX0.KYSNg6-2j-PiAyIo1pAhSflG6z6dmxmT97bqTQgABvXoAQL-h1lR90eF6J9LMZtSywqm6TPNW566o5EQurkiQ5GtPMwq-x267t8U4DX7O9Z4niB9kazlZ-3muOgJyW-NSfL8cncm2wJtwAIy5R1jRvEpbRyE8N4fclmOJyl_7wlopBZe5HVd7qEYtDdZkxG7bhGt6XjVe6WFWdNsMF5D3zD8KJGuZEkHk7oqBV6s1BNCBDofitRzcnLs50g7jYc_31Dlh1JebNHPnFJpzFAABeSn3KKYbYYctZMHDhPjBdw0E8tZ1gSy_b8Nov8ZUPKatv5XimEWPaXgzC5ngVw5UlWaFXNs5P0_-XnYacBPJMEMrA7dN7WAv5koch9EQyJYrAkcnIb23jSV7CmXakfJoZKRns3LqxPmC6vP1aAQdHoRd5T_-xUxBb0SkPpzaEmKdZ7JKvTip7cw0vH0677IuaZhDGuGIZPgh4IB5xjQ0OgSS4NsdQ3rc3n72iDJ90D1hf7BRxU-XHIkElwisJGrBND6BGFflxmBTizIUOsAKqP-FTeX0_fNgytMoIvHy5T1rSOb9qJJYwJIt1P8WHAxxd_l5o3TWAHf382-3WYVkgid6x5aq8sJ2YQ8RZoNnQdDAl_72rrXgXvudGGMwZGg6Cg88h2Ki5WeOYvA2wfpbcw",
          // purposes: [
          //   {
          //     Id: "34820d73-e92b-497b-a2ae-6149b14fe3dd",
          //     // TransactionType: "CONFIRMED",
          //     TransactionType: "WITHDRAWN",
          //   },
          // ],
          // **** PRODUCTION END ****
          requestInformation: `${ONETRUST_PRIVACY.TOKEN}`,
          purposes: [
            {
              Id: `${ONETRUST_PRIVACY.ID}`,
              TransactionType: "WITHDRAWN",
            },
          ],
        });
      }
      if (isPersonalInformation === true) {
        axios.post(OneTrust, {
          identifier: user?.phone,
          // **** UAT START ****
          // requestInformation:
          //   "eyJhbGciOiJSUzUxMiJ9.eyJvdEp3dFZlcnNpb24iOjEsInByb2Nlc3NJZCI6IjYzYjg3ZmQ5LWU5M2ItNGJlMy1iMTZiLWEzOGU5NmRlMzQ0OCIsInByb2Nlc3NWZXJzaW9uIjoyLCJpYXQiOiIyMDIyLTA1LTMxVDA5OjEzOjM3LjE2IiwibW9jIjoiQVBJIiwicG9saWN5X3VyaSI6bnVsbCwic3ViIjoiRW1haWwiLCJpc3MiOm51bGwsInRlbmFudElkIjoiNjY5MjQ3ZjAtYjAyOC00ZjdlLWE4MTktNWU3ODA1NDZiYTA2IiwiZGVzY3JpcHRpb24iOiJQcm9tcHREZWVfUGFydG5lclNoaXAgQnV5ZXIiLCJjb25zZW50VHlwZSI6IkNPTkRJVElPTkFMVFJJR0dFUiIsImFsbG93Tm90R2l2ZW5Db25zZW50cyI6ZmFsc2UsImRvdWJsZU9wdEluIjpmYWxzZSwicHVycG9zZXMiOlt7ImlkIjoiODNkYTFmYzMtYjgzNS00YzcyLThhM2UtNTBkZjk4ZTJiYjAxIiwidmVyc2lvbiI6MSwicGFyZW50SWQiOm51bGwsInRvcGljcyI6W10sImN1c3RvbVByZWZlcmVuY2VzIjpbXSwiZW5hYmxlR2VvbG9jYXRpb24iOmZhbHNlfV0sIm5vdGljZXMiOltdLCJkc0RhdGFFbGVtZW50cyI6W10sImF1dGhlbnRpY2F0aW9uUmVxdWlyZWQiOmZhbHNlLCJyZWNvbmZpcm1BY3RpdmVQdXJwb3NlIjpmYWxzZSwib3ZlcnJpZGVBY3RpdmVQdXJwb3NlIjp0cnVlLCJkeW5hbWljQ29sbGVjdGlvblBvaW50IjpmYWxzZSwiYWRkaXRpb25hbElkZW50aWZpZXJzIjpbXSwibXVsdGlwbGVJZGVudGlmaWVyVHlwZXMiOmZhbHNlLCJlbmFibGVQYXJlbnRQcmltYXJ5SWRlbnRpZmllcnMiOmZhbHNlLCJwYXJlbnRQcmltYXJ5SWRlbnRpZmllcnNUeXBlIjpudWxsLCJhZGRpdGlvbmFsUGFyZW50SWRlbnRpZmllclR5cGVzIjpbXSwiZW5hYmxlR2VvbG9jYXRpb24iOmZhbHNlfQ.r3y1_CSGzYB3SYXxhIBiCL5BpVJLAlB1wZdKxfYHvI3wK59zkwrSfCqrwLgXvFd0wcbOr7bhVeVrusLN23UoBI6MZbITJHy8Gf_kcHjLie7upGv4I_HXMH_s3IxeNFVD__2j2LO9_NEleAvGy3PM8z1AuM1LZbOq-h_lnQ0VbLX9xeruo5zrZXTyAda75F-CKVd0aKxm-5AXoJdUH7AFiDuWBqrYI52Z6qyWRCTuRULPRWm4evJque7YzCndClVpQYfUfpaGWsT8-eZOP-fBSZmKfbF0Yr6EUbw-MKR1t0J9qAFCsUAjjIo-zmxWJ4B6HfCJdpEq91Y_q_q3K3mEggsTaov294feVUyZ_Esi_mA5KeG-ocLbchZnBTHqNxZ4K4hashNq0Uxs-3bMYfol7-o7EvZDXvFNiDIsdz3FdcrsEpzgml3wCopBTd6ZDo-8NJWSAnSGmESZyjvV1M2ENfGTS0H_wSkKg7XVisALRZnNQWqHEaeo2RdutNcz6UTclft8MTrzoI7u8qnVVX0mXjmTUuRXHq8D_Wbzv75yTW9usjPxI5LkY0jmgXcqmOjrEbmdAX_X1K9Obv9HaiR_6n1EzPf74FE83-bVzaf3JdwzU952W2AXZYLLzo6UzQS4lvg_2bSNZDRk0B2hz-zzZx3f9l2PiV8dOnHHBg8PnjQ",
          // purposes: [
          //   {
          //     Id: "83da1fc3-b835-4c72-8a3e-50df98e2bb01",
          //     TransactionType: "CONFIRMED",
          //     //   "TransactionType": "WITHDRAWN"
          //   },
          // ],
          // **** UAT END ****
          // **** PRODUCTION START ****
          // requestInformation:
          //   "eyJhbGciOiJSUzUxMiJ9.eyJvdEp3dFZlcnNpb24iOjEsInByb2Nlc3NJZCI6ImE4NjU5ZjJlLTA3MGYtNGE2Ni04MDBmLWMxYjQ0YTRmYjkzYiIsInByb2Nlc3NWZXJzaW9uIjoxLCJpYXQiOiIyMDIyLTA1LTI3VDA2OjMxOjI2LjM1IiwibW9jIjoiQVBJIiwicG9saWN5X3VyaSI6bnVsbCwic3ViIjoiRW1haWwiLCJpc3MiOm51bGwsInRlbmFudElkIjoiNTcwZGM0ZTAtNjFmZC00OTI2LTkwOTQtMjkwZDdiNWIzY2I2IiwiZGVzY3JpcHRpb24iOiJQcm9tcHREZWVfUGFydG5lclNoaXAgQnV5ZXIgVUFUIiwiY29uc2VudFR5cGUiOiJDT05ESVRJT05BTFRSSUdHRVIiLCJhbGxvd05vdEdpdmVuQ29uc2VudHMiOmZhbHNlLCJkb3VibGVPcHRJbiI6ZmFsc2UsInB1cnBvc2VzIjpbeyJpZCI6IjZhZTk1MzQwLTEyOWMtNDQyMy05MGFhLTNjNTU4ZTZhOTI0YSIsInZlcnNpb24iOjEsInBhcmVudElkIjpudWxsLCJ0b3BpY3MiOltdLCJjdXN0b21QcmVmZXJlbmNlcyI6W10sImVuYWJsZUdlb2xvY2F0aW9uIjpmYWxzZX1dLCJub3RpY2VzIjpbXSwiZHNEYXRhRWxlbWVudHMiOltdLCJhdXRoZW50aWNhdGlvblJlcXVpcmVkIjpmYWxzZSwicmVjb25maXJtQWN0aXZlUHVycG9zZSI6ZmFsc2UsIm92ZXJyaWRlQWN0aXZlUHVycG9zZSI6dHJ1ZSwiZHluYW1pY0NvbGxlY3Rpb25Qb2ludCI6ZmFsc2UsImFkZGl0aW9uYWxJZGVudGlmaWVycyI6W10sIm11bHRpcGxlSWRlbnRpZmllclR5cGVzIjpmYWxzZSwiZW5hYmxlUGFyZW50UHJpbWFyeUlkZW50aWZpZXJzIjpmYWxzZSwicGFyZW50UHJpbWFyeUlkZW50aWZpZXJzVHlwZSI6bnVsbCwiYWRkaXRpb25hbFBhcmVudElkZW50aWZpZXJUeXBlcyI6W10sImVuYWJsZUdlb2xvY2F0aW9uIjpmYWxzZX0.if58qKuMMq-AEhjzRNM7GHTNWps9OTDwzQqjEnmvMe0DXk7iPNjO0I53sShx7EKZe5zcVIAYZvObJdiac1zKsrCNhcU2bvM7GX8osUAWlbbcIg66EEbTHeFcu1thJa43CXZNWfK4_6Gk8rHUc0NzwlEqC0o-XPwaJA8wUzsH7sBI8s17yt3mUfimBnLZK5OqbEozy68HsOOgw9BaT1_QEfbWj5s4XqG6VHkx-UHNWSVq7Jwp3yfpEAB0uITkCmW2pbFL26dB9QvNUjOqo25-djFQCtU9CMGMixX8hgIZZgdJef0d4gq36hrUyDXiAXtpM1eMbOjjBJt4O2AHHibKn-bOyTOiTdPSdb01nbIMZ-ZLohJjmgo31e1nPC4CM7qnFfWvFrlVuVEW59E_BjYiVudvJSur2cPkzwjrKrgtBQZExudj4wSHkGDmgx3EVt5Ea88gl-UIhlypUFXWNkEzX_PlWHT_2y1pKOf8Lc1vxh1STKlsokecdGqL2wdWwCUIfw26hAIUp6toZVxPlhask7_opMi9gVytyRAHqArb_Ex-KYJzHfLnUne5jDadJT7VL3YyuTpwrXBdpE0jVAB2C93ComCcEGCv6Uj_b4AQCuV0oSyikOOAVFmhVmdA6XrPGA8b0RR5Qbd6SEjQBjvRQgPla6chfDPpvy0gpe7s7-k",
          // purposes: [
          //   {
          //     Id: "6ae95340-129c-4423-90aa-3c558e6a924a",
          //     TransactionType: "CONFIRMED",
          //     //   "TransactionType": "WITHDRAWN"
          //   },
          // ],
          // **** PRODUCTION END ****
          requestInformation: `${ONETRUST_SHARED_DATA.TOKEN}`,
          purposes: [
            {
              Id: `${ONETRUST_SHARED_DATA.ID}`,
              TransactionType: "CONFIRMED",
            },
          ],
        });
      } else {
        axios.post(OneTrust, {
          identifier: user?.phone,
          // **** UAT START ****
          // requestInformation:
          //   "eyJhbGciOiJSUzUxMiJ9.eyJvdEp3dFZlcnNpb24iOjEsInByb2Nlc3NJZCI6IjYzYjg3ZmQ5LWU5M2ItNGJlMy1iMTZiLWEzOGU5NmRlMzQ0OCIsInByb2Nlc3NWZXJzaW9uIjoyLCJpYXQiOiIyMDIyLTA1LTMxVDA5OjEzOjM3LjE2IiwibW9jIjoiQVBJIiwicG9saWN5X3VyaSI6bnVsbCwic3ViIjoiRW1haWwiLCJpc3MiOm51bGwsInRlbmFudElkIjoiNjY5MjQ3ZjAtYjAyOC00ZjdlLWE4MTktNWU3ODA1NDZiYTA2IiwiZGVzY3JpcHRpb24iOiJQcm9tcHREZWVfUGFydG5lclNoaXAgQnV5ZXIiLCJjb25zZW50VHlwZSI6IkNPTkRJVElPTkFMVFJJR0dFUiIsImFsbG93Tm90R2l2ZW5Db25zZW50cyI6ZmFsc2UsImRvdWJsZU9wdEluIjpmYWxzZSwicHVycG9zZXMiOlt7ImlkIjoiODNkYTFmYzMtYjgzNS00YzcyLThhM2UtNTBkZjk4ZTJiYjAxIiwidmVyc2lvbiI6MSwicGFyZW50SWQiOm51bGwsInRvcGljcyI6W10sImN1c3RvbVByZWZlcmVuY2VzIjpbXSwiZW5hYmxlR2VvbG9jYXRpb24iOmZhbHNlfV0sIm5vdGljZXMiOltdLCJkc0RhdGFFbGVtZW50cyI6W10sImF1dGhlbnRpY2F0aW9uUmVxdWlyZWQiOmZhbHNlLCJyZWNvbmZpcm1BY3RpdmVQdXJwb3NlIjpmYWxzZSwib3ZlcnJpZGVBY3RpdmVQdXJwb3NlIjp0cnVlLCJkeW5hbWljQ29sbGVjdGlvblBvaW50IjpmYWxzZSwiYWRkaXRpb25hbElkZW50aWZpZXJzIjpbXSwibXVsdGlwbGVJZGVudGlmaWVyVHlwZXMiOmZhbHNlLCJlbmFibGVQYXJlbnRQcmltYXJ5SWRlbnRpZmllcnMiOmZhbHNlLCJwYXJlbnRQcmltYXJ5SWRlbnRpZmllcnNUeXBlIjpudWxsLCJhZGRpdGlvbmFsUGFyZW50SWRlbnRpZmllclR5cGVzIjpbXSwiZW5hYmxlR2VvbG9jYXRpb24iOmZhbHNlfQ.r3y1_CSGzYB3SYXxhIBiCL5BpVJLAlB1wZdKxfYHvI3wK59zkwrSfCqrwLgXvFd0wcbOr7bhVeVrusLN23UoBI6MZbITJHy8Gf_kcHjLie7upGv4I_HXMH_s3IxeNFVD__2j2LO9_NEleAvGy3PM8z1AuM1LZbOq-h_lnQ0VbLX9xeruo5zrZXTyAda75F-CKVd0aKxm-5AXoJdUH7AFiDuWBqrYI52Z6qyWRCTuRULPRWm4evJque7YzCndClVpQYfUfpaGWsT8-eZOP-fBSZmKfbF0Yr6EUbw-MKR1t0J9qAFCsUAjjIo-zmxWJ4B6HfCJdpEq91Y_q_q3K3mEggsTaov294feVUyZ_Esi_mA5KeG-ocLbchZnBTHqNxZ4K4hashNq0Uxs-3bMYfol7-o7EvZDXvFNiDIsdz3FdcrsEpzgml3wCopBTd6ZDo-8NJWSAnSGmESZyjvV1M2ENfGTS0H_wSkKg7XVisALRZnNQWqHEaeo2RdutNcz6UTclft8MTrzoI7u8qnVVX0mXjmTUuRXHq8D_Wbzv75yTW9usjPxI5LkY0jmgXcqmOjrEbmdAX_X1K9Obv9HaiR_6n1EzPf74FE83-bVzaf3JdwzU952W2AXZYLLzo6UzQS4lvg_2bSNZDRk0B2hz-zzZx3f9l2PiV8dOnHHBg8PnjQ",
          // purposes: [
          //   {
          //     Id: "83da1fc3-b835-4c72-8a3e-50df98e2bb01",
          //     // TransactionType: "CONFIRMED",
          //     TransactionType: "WITHDRAWN",
          //   },
          // ],
          // **** UAT END ****
          // **** PRODUCTION START ****
          // requestInformation:
          //   "eyJhbGciOiJSUzUxMiJ9.eyJvdEp3dFZlcnNpb24iOjEsInByb2Nlc3NJZCI6ImE4NjU5ZjJlLTA3MGYtNGE2Ni04MDBmLWMxYjQ0YTRmYjkzYiIsInByb2Nlc3NWZXJzaW9uIjoxLCJpYXQiOiIyMDIyLTA1LTI3VDA2OjMxOjI2LjM1IiwibW9jIjoiQVBJIiwicG9saWN5X3VyaSI6bnVsbCwic3ViIjoiRW1haWwiLCJpc3MiOm51bGwsInRlbmFudElkIjoiNTcwZGM0ZTAtNjFmZC00OTI2LTkwOTQtMjkwZDdiNWIzY2I2IiwiZGVzY3JpcHRpb24iOiJQcm9tcHREZWVfUGFydG5lclNoaXAgQnV5ZXIgVUFUIiwiY29uc2VudFR5cGUiOiJDT05ESVRJT05BTFRSSUdHRVIiLCJhbGxvd05vdEdpdmVuQ29uc2VudHMiOmZhbHNlLCJkb3VibGVPcHRJbiI6ZmFsc2UsInB1cnBvc2VzIjpbeyJpZCI6IjZhZTk1MzQwLTEyOWMtNDQyMy05MGFhLTNjNTU4ZTZhOTI0YSIsInZlcnNpb24iOjEsInBhcmVudElkIjpudWxsLCJ0b3BpY3MiOltdLCJjdXN0b21QcmVmZXJlbmNlcyI6W10sImVuYWJsZUdlb2xvY2F0aW9uIjpmYWxzZX1dLCJub3RpY2VzIjpbXSwiZHNEYXRhRWxlbWVudHMiOltdLCJhdXRoZW50aWNhdGlvblJlcXVpcmVkIjpmYWxzZSwicmVjb25maXJtQWN0aXZlUHVycG9zZSI6ZmFsc2UsIm92ZXJyaWRlQWN0aXZlUHVycG9zZSI6dHJ1ZSwiZHluYW1pY0NvbGxlY3Rpb25Qb2ludCI6ZmFsc2UsImFkZGl0aW9uYWxJZGVudGlmaWVycyI6W10sIm11bHRpcGxlSWRlbnRpZmllclR5cGVzIjpmYWxzZSwiZW5hYmxlUGFyZW50UHJpbWFyeUlkZW50aWZpZXJzIjpmYWxzZSwicGFyZW50UHJpbWFyeUlkZW50aWZpZXJzVHlwZSI6bnVsbCwiYWRkaXRpb25hbFBhcmVudElkZW50aWZpZXJUeXBlcyI6W10sImVuYWJsZUdlb2xvY2F0aW9uIjpmYWxzZX0.if58qKuMMq-AEhjzRNM7GHTNWps9OTDwzQqjEnmvMe0DXk7iPNjO0I53sShx7EKZe5zcVIAYZvObJdiac1zKsrCNhcU2bvM7GX8osUAWlbbcIg66EEbTHeFcu1thJa43CXZNWfK4_6Gk8rHUc0NzwlEqC0o-XPwaJA8wUzsH7sBI8s17yt3mUfimBnLZK5OqbEozy68HsOOgw9BaT1_QEfbWj5s4XqG6VHkx-UHNWSVq7Jwp3yfpEAB0uITkCmW2pbFL26dB9QvNUjOqo25-djFQCtU9CMGMixX8hgIZZgdJef0d4gq36hrUyDXiAXtpM1eMbOjjBJt4O2AHHibKn-bOyTOiTdPSdb01nbIMZ-ZLohJjmgo31e1nPC4CM7qnFfWvFrlVuVEW59E_BjYiVudvJSur2cPkzwjrKrgtBQZExudj4wSHkGDmgx3EVt5Ea88gl-UIhlypUFXWNkEzX_PlWHT_2y1pKOf8Lc1vxh1STKlsokecdGqL2wdWwCUIfw26hAIUp6toZVxPlhask7_opMi9gVytyRAHqArb_Ex-KYJzHfLnUne5jDadJT7VL3YyuTpwrXBdpE0jVAB2C93ComCcEGCv6Uj_b4AQCuV0oSyikOOAVFmhVmdA6XrPGA8b0RR5Qbd6SEjQBjvRQgPla6chfDPpvy0gpe7s7-k",
          // purposes: [
          //   {
          //     Id: "6ae95340-129c-4423-90aa-3c558e6a924a",
          //     // TransactionType: "CONFIRMED",
          //     TransactionType: "WITHDRAWN",
          //   },
          // ],
          // **** PRODUCTION END ****
          requestInformation: `${ONETRUST_SHARED_DATA.TOKEN}`,
          purposes: [
            {
              Id: `${ONETRUST_SHARED_DATA.ID}`,
              TransactionType: "WITHDRAWN",
            },
          ],
        });
      }

      let datePersonal =
        data?.data?.pdpaDetail?.personalInformation?.acceptDate;
      if (isPersonalInformation != data.data.pdpa.personalInformation) {
        datePersonal = datetoset;
      }
      const checkBoxsUser = axios.patch(`/pdpa-user/${user?._id}`, {
        pdpa: {
          privacyPolicy: data.data.pdpa.privacyPolicy,
          termsConditions: data.data.pdpa.termsConditions,
          news: isNew,
          personalInformation: isPersonalInformation,
        },
        pdpaDetail: {
          privacyPolicy: {
            version: data.data.pdpaDetail.privacyPolicy.version,
            acceptDate: data.data.pdpaDetail.privacyPolicy.acceptDate,
          },
          termsConditions: {
            version: data.data.pdpaDetail.termsConditions.version,
            acceptDate: data.data.pdpaDetail.termsConditions.acceptDate,
          },
          news: {
            version: data.data.pdpaDetail.news.version,
            acceptDate: dataNew,
          },
          personalInformation: {
            version: data.data.pdpaDetail.personalInformation.version,
            acceptDate: datePersonal,
          },
        },
      });
      const checkBoxsLog = await axios.post(`/pdpa-log`, {
        userId: user?._id,
        version: "1",
        pdpa: {
          privacyPolicy: data.data.pdpa.privacyPolicy,
          termsConditions: data.data.pdpa.termsConditions,
          news: isNew,
          personalInformation: isPersonalInformation,
        },
        pdpaDetail: {
          privacyPolicy: {
            version: data.data.pdpaDetail.privacyPolicy.version,
            acceptDate: data.data.pdpaDetail.privacyPolicy.acceptDate,
          },
          termsConditions: {
            version: data.data.pdpaDetail.termsConditions.version,
            acceptDate: data.data.pdpaDetail.termsConditions.acceptDate,
          },
          news: {
            version: data.data.pdpaDetail.news.version,
            acceptDate: dataNew,
          },
          personalInformation: {
            version: data.data.pdpaDetail.personalInformation.version,
            acceptDate: datePersonal,
          },
        },
      });
      // window.location.reload();
    });
    message.success("แก้ไขข้อมูลสำเร็จ");
  };
  useEffect(() => {
    axios.get(`/pdpa-user/${user?._id}`).then((data) => {
      // console.log(data?.data);
      setPersonalInformation(data?.data?.pdpa?.personalInformation);
      setNew(data?.data?.pdpa?.news);
    });
    // **** UAT START ****
    // const ONETRUST_TERMS_OF_USE = `https://privacyportal-uat-cdn.onetrust.com/669247f0-b028-4f7e-a819-5e780546ba06/privacy-notices/draft/c8f82f23-04c7-4ab9-9b97-ffc362d5c1d3-th-th.json`;
    // **** UAT END ****
    // **** PRODUCTION START ****
    // const ONETRUST_TERMS_OF_USE = `https://privacyportal-uat-cdn.onetrust.com/669247f0-b028-4f7e-a819-5e780546ba06/privacy-notices/draft/c8f82f23-04c7-4ab9-9b97-ffc362d5c1d3-th-th.json`;
    // **** PRODUCTION END ****
    const ONETRUST_TERMS_OF_USE = `${ONETRUST_TERMS_OF_USE_URL}`;
    fetch(ONETRUST_TERMS_OF_USE)
      .then((response) => response.json())
      .then((jsonData) => {
        // jsonData is parsed json object received from url
        const aaaa = jsonData.notices[Object.keys(jsonData.notices)[0]];

        setNotices1(aaaa.content);
      })
      .catch((error) => {
        // handle your errors here
        console.error(error);
      });
    // **** UAT START ****
    // const ONETRUST_PROVACTY_POLICY = `https://privacyportal-uat-cdn.onetrust.com/669247f0-b028-4f7e-a819-5e780546ba06/privacy-notices/draft/c9e0a095-10ca-4969-8b5a-694beb4cc794-th-th.json`;
    // **** UAT END ****
    // **** PRODUCTION START ****
    // const ONETRUST_PROVACTY_POLICY = `https://privacyportal-uat-cdn.onetrust.com/669247f0-b028-4f7e-a819-5e780546ba06/privacy-notices/draft/c9e0a095-10ca-4969-8b5a-694beb4cc794-th-th.json`;
    // **** PRODUCTION END ****
    const ONETRUST_PROVACTY_POLICY = `${ONETRUST_PRIVACY_POLICY_URL}`;
    fetch(ONETRUST_PROVACTY_POLICY)
      .then((response) => response.json())
      .then((jsonData) => {
        // jsonData is parsed json object received from url
        const aaaa = jsonData.notices[Object.keys(jsonData.notices)[0]];

        setNotices2(aaaa.content);
      })
      .catch((error) => {
        // handle your errors here
        console.error(error);
      });
  }, [user]);
  useEffect(() => {
    // console.log(isNew);
  }, [isNew]);
  useEffect(() => {
    // console.log(isPersonalInformation);
  }, [isPersonalInformation]);
  useEffect(() => {
    getTerm();
  }, []);
  return (
    <>
      <Layout breadcrumbItems={breadcrumbs} breadcrumbMarginBottom={50}>
        <div className={styles.wrapper}>
          <div className={styles.topBody} style={{ marginTop: 70 }}></div>
          <Col xs={24} lg={24} style={{ marginBottom: 20 }}>
            <Modal
              visible={isAgreement}
              centered
              footer={false}
              // width={"60%"}
              closeIcon
              className={styles.modalPolicy}
            >
              <div
                // bordered={false}
                className={[styles.cardBody].join(" ")}
                style={{ overflow: "auto", height: "50vh" }}
              >
                {/* <div id="bottomModal" style={{ marginTop: 50 }}></div> */}
                <div
                  className="otnotice"
                  dangerouslySetInnerHTML={{
                    __html: term ? term : "",
                  }}
                ></div>
              </div>
              <div
                style={{
                  marginTop: 30,
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Button onClick={clossModal}>ปิด</Button>
              </div>
            </Modal>
            <Modal
              visible={isAgreementData}
              centered
              footer={false}
              // width={"60%"}
              closeIcon
              className={styles.modalPolicy}
            >
              <div
                // bordered={false}
                className={styles.cardBody}
                style={{ overflow: "auto", height: "50vh" }}
              >
                {/* <PrivacyNotice /> */}
                {notices2 ? (
                  <div
                    id="otnotice-f4d306bf-5d80-428d-be47-d8e406eeec9a"
                    className="otnotice"
                    dangerouslySetInnerHTML={{
                      __html: notices2,
                    }}
                  ></div>
                ) : (
                  <></>
                )}
              </div>
              <div
                style={{
                  marginTop: 30,
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                {/* <Checkbox
                            disabled={isScrollingData}
                            checked={!isPrivacy}
                            onChange={() => setIsPrivacy(!isPrivacy)}
                            style={{ padding: 6 }}
                          >
                            ยอมรับเงื่อนไข
                          </Checkbox> */}
                <Button onClick={clossModal}>ตกลง</Button>
              </div>
            </Modal>

            <div style={{ display: "flex", marginBottom: 10 }}>
              <Checkbox
                // disabled={isScrolling}
                checked={isNew}
                onChange={(e) => setNew(e.target.checked)}
                style={{ marginTop: 2, marginRight: 10 }}
              ></Checkbox>
              <div>
                <span style={{ fontSize: 14 }}>
                  ข้าพเจ้ายินยอมรับข่าวสารและสิทธิประโยชน์ ผ่านทางอีเมล
                  เอสเอ็มเอส แอปพลิเคชัน โซเชียลมีเดีย โทรศัพท์
                  และไดเร็กเมลจากบริษัท เอสซีจี ดิสทริบิวชั่น จำกัด ผู้ให้บริการ
                  PromptDee
                </span>
              </div>
            </div>
            <Modal
              visible={isNetwork}
              centered
              footer={false}
              // width={"60%"}
              closeIcon
              className={styles.modalPolicy}
            >
              <div
                // bordered={false}
                className={styles.cardBody}
                //style={{ overflow: "auto", height: "50vh" }}
                // onScroll={() => onScrollData()}
              >
                <NetworkData />
                <div id="bottomModal" style={{ marginTop: 50 }}></div>
              </div>
              <div
                style={{
                  marginTop: 30,
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Button onClick={clossModal}>ปิด</Button>
              </div>
            </Modal>
            <div style={{ display: "flex", marginBottom: 10 }}>
              <Checkbox
                // disabled={isScrolling}
                checked={isPersonalInformation}
                onChange={(e) => setPersonalInformation(e.target.checked)}
                style={{ marginTop: 2, marginRight: 10 }}
              ></Checkbox>
              <div>
                <span style={{ fontSize: 14 }}>
                  ข้าพเจ้ายินยอมให้ส่งข้อมูลส่วนบุคคลให้กับ{" "}
                </span>
                <span
                  style={{
                    fontSize: 14,
                    color: "#1890FF",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                  onClick={openModalNetwork}
                >
                  บริษัทในเครือของเอสซีจี และบริษัทพันธมิตร
                </span>
                <span style={{ fontSize: 14 }}>
                  {" "}
                  เพื่อรับข่าวสารและสิทธิประโยชน์เกี่ยวกับสินค้าและบริการ
                  ผ่านทางอีเมล เอสเอ็มเอส แอปพลิเคชัน โซเชียลมีเดีย โทรศัพท์
                  และไดเร็กเมล จากบริษัทดังกล่าว
                </span>
              </div>
            </div>
            <div style={{ display: "flex", marginBottom: 10 }}>
              <Checkbox
                disabled={true}
                checked={true}
                // onChange={(e) => setIsCheckerbox(e.target.checked)}
                style={{ marginTop: 2, marginRight: 10 }}
              ></Checkbox>
              <div>
                <span style={{ fontSize: 14 }}>ข้าพเจ้าเข้าใจและตกลงตาม </span>
                <span
                  style={{
                    fontSize: 14,
                    color: "#1890FF",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                  onClick={setIsAgreement}
                >
                  ข้อกำหนดและเงื่อนไข
                </span>
                <span style={{ fontSize: 14 }}>
                  {" "}
                  รวมทั้งเข้าใจถึงเรื่องการเก็บ ใช้ และเปิดเผยข้อมูลส่วนบุคคลตาม{" "}
                </span>
                <span
                  style={{
                    fontSize: 14,
                    color: "#1890FF",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                  onClick={setIsAgreementData}
                >
                  นโยบายความเป็นส่วนตัว
                </span>
                <span style={{ fontSize: 14 }}>
                  {" "}
                  (โปรดกดอ่าน ข้อกำหนดและเงื่อนไข และ นโยบายความเป็นส่วนตัว)
                </span>
              </div>
            </div>
          </Col>
          <Col xs={24} lg={24} className={styles.submitWrapper}>
            <Button
              type="primary"
              htmlType="submit"
              className={styles.btnSubmit}
              onClick={addPdPa}
            >
              ยืนยัน
            </Button>
          </Col>
        </div>
      </Layout>
    </>
  );
};
export default Notice;
function useModel(arg0: string): { initialState: any; setInitialState: any } {
  throw new Error("Function not implemented.");
}
